export const searchBy = <T>(
  array: T[],
  fields: (keyof T)[],
  searchString: string
) =>
  array.filter((value) =>
    fields.some((fieldName) =>
      String(value[fieldName])
        .toLowerCase()
        .includes(searchString.toLowerCase())
    )
  )
